// extracted by mini-css-extract-plugin
module.exports = {"root":"ValidationError_root__2BqiA"};